import React, { useEffect, useState } from 'react';
import { Bot, getDailyReport } from "../bot-loaders";
import { DateUtils, groupBy } from 'simple-utils';
import { ChartPoint, LineChart, Serie, SpotItem } from 'react-charts';
import { getLabel, getStyle } from './message-chart-loader';
import { monthName, normalizeDateItems } from 'simple-utils/dist/date-utils';

type Status = string
type DateStr = string
type DailyReport = [DateStr, Status, number];

function normalizeReport(entries: DailyReport[]):DailyReport[] {
    const byDate = groupBy(entries, e => e[0].substring(0,10))
    const result:DailyReport[] = [];
    for(let [s, dates] of Object.entries(byDate)){
        const sent = dates.find(i => i[1] == 'sent') || [s, 'sent', 0];
        const delivered = dates.find(i => i[1] == 'delivered') || [s, 'delivered', 0];
        const read = dates.find(i => i[1] == 'read') || [s, 'read', 0];

        result.push([s, 'sent', sent[2] + read[2] + delivered[2]])
        result.push([s, 'delivered', read[2] + delivered[2]])
        result.push(read);
    }

    return result;
}

function getData(entry: DailyReport[]):ChartPoint[]{
    var temp = entry.map(e => {
        let date = DateUtils.parseDate(e[0].substring(0,10));
        return {
            date,
            x: date.getTime(),
            y: e[2]
        }
    });
    temp = normalizeDateItems(temp, e => e.date, date => ({date, x: date.getTime(), y: 0}));
    return temp;
}

function reportToSeries(data:DailyReport[]){
    const byStatus = groupBy(normalizeReport(data), a => a[1]);
    const result:Serie[] = [];
    for(let [s, dates] of Object.entries(byStatus)){
        const serie:Serie = {
            label: getLabel(s),
            style: getStyle(s),
            data: getData(dates)
        }

        if(s == 'read')
            serie.lineStyle = "dot";
        
        result.push(serie);
    }

    return result;
    
}

function xLabel(n:number){
    const date = new Date();
    date.setTime(n);
    return `${date.getDate()}/${monthName(date, true)}`;
}   

function createTooltipDate(e: SpotItem[]){
    if(e == null) return null;
    return <>
        <div className="mb-1">        
            <b>Views</b><br />
            {DateUtils.formatDate(e[0].item.date)}<br />
            <b className={`ms-0 bg-primary badge mb-2`}>{DateUtils.weekDayLabel(e[0].item.date)}</b><br />
            {e.map((i, index) => {
                return <div key={index} className=''><i style={{fontSize:"10px", verticalAlign:"25%"}} className={`${i.serie.style} text-color fa fa-circle me-1`}></i><b>{i.item.y}</b> {i.serie.label}</div>
            })}
            
        </div>
    </>
}

export  function BotDailyReport({bot}:{bot:Bot}){
    const [data, setData] = useState<Serie[]>(null);
    const [loading, setLoading] = useState(true);

    useEffect(function(){
        setLoading(true);
        (async () => {
            try{
                const report = await getDailyReport(bot);
                setData(reportToSeries(report));
                setLoading(false);
            }catch(e){
                setLoading(false);
            }
        })();
    }, [bot.id]);

    if(loading)
        return <div className='mt-2'>Carregando...</div>

    if(!data)
        return null;

    return <div className='daily-report'>
        <LineChart  data={data} height={300} xLabelFunction={xLabel} createTooltip={createTooltipDate} /> 
    </div>
}